const vehicles = [
  {
    id: 'bmw740i',
    name: '2026 BMW 740i',
    color: 'Midnight Blue',
    colorTag: 'Blue',
    image: 'https://public.readdy.ai/ai/img_res/3a1fd7830ede5fbd39d49fe30da6d2d1.jpg',
    badge: 'Premium',
    seats: '4 Passengers',
    features: ['Professional Chauffeur', 'Climate Control', 'Premium Audio', 'Leather Interior'],
    pricing: [
      { type: 'Drop-Off Only', price: '$1,000' },
      { type: 'Round Trip', price: '$1,200' },
    ],
  },
  {
    id: 'bmw530i',
    name: '2026 BMW 530i',
    color: 'Pearl White',
    colorTag: 'White',
    image: 'https://public.readdy.ai/ai/img_res/edited_911e1cedc3a96eaade5fc2e7d71f4346_9b387f12.jpg',
    badge: 'Executive',
    seats: '3 Passengers',
    features: ['Professional Chauffeur', 'Climate Control', 'Premium Audio', 'Leather Interior'],
    pricing: [
      { type: 'Drop-Off Only', price: '$850' },
      { type: 'Round Trip', price: '$1,000' },
    ],
  },
];

export default function ServicesSection() {
  const scrollToBooking = () => {
    const el = document.querySelector('#booking');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="services" className="py-28 bg-[#050505] relative">
      {/* Section divider */}
      <div className="section-divider mb-20"></div>

      <div className="max-w-6xl mx-auto px-6">
        {/* Heading */}
        <div className="text-center mb-16">
          <p className="text-gray-500 text-xs tracking-[0.35em] uppercase mb-4">Our Fleet</p>
          <h2 className="font-display silver-gradient-text text-5xl md:text-6xl font-semibold tracking-wide mb-6">
            The Experience
          </h2>
          <p className="text-gray-400 text-sm tracking-wide max-w-xl mx-auto leading-relaxed">
            Make your Philadelphia prom night unforgettable. Choose your luxury BMW sedan and arrive like royalty — professional chauffeur always included.
          </p>
        </div>

        {/* Vehicle Cards */}
        <div className="grid md:grid-cols-2 gap-8 mb-12">
          {vehicles.map((v) => (
            <div
              key={v.id}
              className="card-luxury rounded-2xl overflow-hidden transition-all duration-300 cursor-pointer group"
            >
              {/* Car Image */}
              <div className="relative h-60 overflow-hidden">
                <img
                  src={v.image}
                  alt={`${v.name} luxury prom chauffeur Philadelphia`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                <div className="absolute top-4 right-4">
                  <span className="bg-black/70 silver-border text-gray-300 text-xs tracking-[0.15em] uppercase px-3 py-1 rounded-full">
                    {v.badge}
                  </span>
                </div>
                <div className="absolute bottom-4 left-5">
                  <div className="flex items-center gap-2">
                    <div className="w-3 h-3 rounded-full border border-gray-400" style={{ background: v.colorTag === 'Blue' ? '#1a2a4a' : '#f0f0f0' }}></div>
                    <span className="text-gray-300 text-xs">{v.color}</span>
                  </div>
                </div>
              </div>

              {/* Details */}
              <div className="p-6">
                <h3 className="font-display silver-gradient-text text-2xl font-semibold mb-1">
                  {v.name}
                </h3>
                <p className="text-gray-500 text-xs tracking-[0.15em] uppercase mb-5">{v.seats}</p>

                {/* Pricing */}
                <div className="grid grid-cols-2 gap-3 mb-6">
                  {v.pricing.map((p) => (
                    <div
                      key={p.type}
                      className="bg-black/40 border border-gray-800 rounded-xl p-4 text-center hover:border-gray-600 transition-colors"
                    >
                      <p className="text-gray-500 text-[10px] tracking-[0.15em] uppercase mb-2">{p.type}</p>
                      <p className="font-display silver-gradient-text text-2xl font-semibold">{p.price}</p>
                    </div>
                  ))}
                </div>

                {/* Features */}
                <ul className="space-y-2 mb-6">
                  {v.features.map((f) => (
                    <li key={f} className="flex items-center gap-3 text-gray-400 text-xs">
                      <div className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-checkbox-circle-line text-gray-500 text-sm"></i>
                      </div>
                      {f}
                    </li>
                  ))}
                </ul>

                <button
                  onClick={scrollToBooking}
                  className="w-full btn-silver rounded-xl py-3 text-xs tracking-[0.15em] uppercase cursor-pointer whitespace-nowrap"
                >
                  Book This Vehicle
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* Info Banners */}
        <div className="flex flex-col sm:flex-row gap-4">
          <div className="flex-1 bg-[#111111] border border-gray-800 rounded-xl p-5 flex items-center gap-4">
            <div className="w-10 h-10 flex items-center justify-center silver-border rounded-full shrink-0">
              <i className="ri-user-star-line silver-gradient-text-sm text-lg"></i>
            </div>
            <div>
              <p className="text-white text-sm font-medium mb-1">Chauffeur Included</p>
              <p className="text-gray-500 text-xs leading-relaxed">Every booking comes with a professional, uniformed chauffeur.</p>
            </div>
          </div>
          <div className="flex-1 bg-[#111111] border border-gray-800 rounded-xl p-5 flex items-center gap-4">
            <div className="w-10 h-10 flex items-center justify-center silver-border rounded-full shrink-0">
              <i className="ri-calendar-check-line silver-gradient-text-sm text-lg"></i>
            </div>
            <div>
              <p className="text-white text-sm font-medium mb-1">Limited Dates Available</p>
              <p className="text-gray-500 text-xs leading-relaxed">Prom season books fast. Reserve your Philadelphia prom date early.</p>
            </div>
          </div>
          <div className="flex-1 bg-[#111111] border border-gray-800 rounded-xl p-5 flex items-center gap-4">
            <div className="w-10 h-10 flex items-center justify-center silver-border rounded-full shrink-0">
              <i className="ri-shield-check-line silver-gradient-text-sm text-lg"></i>
            </div>
            <div>
              <p className="text-white text-sm font-medium mb-1">$500 Deposit to Book</p>
              <p className="text-gray-500 text-xs leading-relaxed">Non-refundable deposit required to secure your reservation.</p>
            </div>
          </div>
        </div>
      </div>

      <div className="section-divider mt-20"></div>
    </section>
  );
}
